"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
(0, manifest_1.registerSection)({
    type: 'product-grid', label: 'Product grid (filtered)', icon: 'grid-3x3', category: 'products',
    settingsSchema: zod_1.z.object({
        title: zod_1.z.string().max(120).default(''),
        eyebrow: zod_1.z.string().max(60).default(''),
        categoryId: zod_1.z.string().default(''),
        sort: zod_1.z.enum(['relevance', 'price-asc', 'price-desc', 'newest']).default('relevance'),
        columns: zod_1.z.number().int().min(2).max(5).default(4),
        limit: zod_1.z.number().int().min(1).max(48).default(12),
        ..._appearance_1.appearanceShape,
    }),
    defaults: () => ({ title: '', eyebrow: '', categoryId: '', sort: 'relevance', columns: 4, limit: 12, ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'title', label: 'Title', control: 'text', group: 'Content' },
        { name: 'eyebrow', label: 'Eyebrow', control: 'text', group: 'Content' },
        { name: 'categoryId', label: 'Category', control: 'category-id', group: 'Content' },
        { name: 'sort', label: 'Sort', control: 'select', group: 'Content', options: [
                { label: 'Relevance', value: 'relevance' },
                { label: 'Price ↑', value: 'price-asc' },
                { label: 'Price ↓', value: 'price-desc' },
                { label: 'Newest', value: 'newest' },
            ] },
        { name: 'columns', label: 'Columns', control: 'number', min: 2, max: 5, group: 'Content' },
        { name: 'limit', label: 'Max products', control: 'number', min: 1, max: 48, group: 'Content' },
        ..._appearance_1.appearanceFields,
    ],
});
//# sourceMappingURL=product-grid.js.map